import React from 'react';
import AnimatedText from 'react-animated-text-content';
import { Col, Container, Row } from 'react-bootstrap';
import { Check2Circle } from 'react-bootstrap-icons';
import RecycleImg from '../../assets/images/recycle.jpg';

const Solution = () => {
  return (
    <Container fluid className='solution__main__container'>
      <Container>
        <h1 className='plastic__h2 '>
          <AnimatedText
            type='words' // animate words or chars
            animation={{
              x: '200px',
              y: '-20px',
              scale: 1.1,
              ease: 'ease-in-out',
            }}
            animationType='throw'
            interval={0.06}
            duration={1}
            tag='p'
            className='animated-paragraph'
            includeWhiteSpaces
            threshold={0.1}
            rootMargin='20%'
          >
            The Ultimate Solution to Eliminate Plastic Waste
          </AnimatedText>
        </h1>

        <Row>
          <Col className='p__box'>
            <p className='plastic__p2'>
              Recycling is growing more popular as people become more conscious
              of plastic waste, but recycling is not the only solution. Reducing
              the use of plastic, as well as investing in Innova materials, is
              the most efficient method to eliminate plastic pollution from this
              planet.
            </p>
            <p className='plastic__p2 '>
              To address the rising demand for recovered plastics, investment
              should be focused on large-scale plastic recycling. Consumers
              should find the finished product beneficial and appealing. The
              competition will expand as demand for recycled plastics rises.
              Different-sized plastic recycling facilities will increase,
              recycling rates will rise, and plastic trash production will
              decline.
            </p>
            <p className='plastic__p2 '>
              We will reuse trashed plastic from the earth and the ocean to
              create stunning and valuable NFTs. Each Kutee kitty's revenue will
              be reinvested back into the project to pay for contractors to
              eliminate additional plastic debris from the land and seas. All
              used plastic will be transferred to our expanding network of
              recycling facilities, where the kutee kitties may be delivered to
              surrounding buyers. The more Kutee kitties are sold, the more
              trendy the collection will become. People will want to own them as
              they become more fashionable. More money will be invested in
              plastic cleanup and recycling initiatives as more individuals
              acquire our NFTs.
            </p>
            <p className='plastic__p2 '>
              Furthermore, competition will cause other enterprises to gather
              plastic waste to recycle. Our strategy is self-sustaining and has
              many positive and attainable ripple effects. We opted for NFT
              technology because it allows us to reap the advantages of our
              investment through utilities, benefiting both the environment and
              individuals who own the NFT. NFT holders will earn 20% of
              investment revenue in funding any programmer involving
              environmental preservation, making this a passive income for NFT
              holders.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Solution;
